import { render } from "./ConfigurationComponent.vue?vue&type=template&id=0d01eae0&scoped=true"
import script from "./ConfigurationComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurationComponent.vue?vue&type=script&lang=js"

import "./ConfigurationComponent.vue?vue&type=style&index=0&id=0d01eae0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d01eae0"]])

export default __exports__